import Header from "components/header";
import Tracker from "components/tracker";
import useRedirect from "hooks/redirect";

const TrackerPage = () => {
  useRedirect();

  return (
    <>
      <Header />
      <Tracker />
    </>
  );
};

export default TrackerPage;
